app.pages = app.pages || {};

app.pages.products = {
    init: () => {
        app.pages.products.filter = app.filter.init({
            hash: 'pf',
            loadingDelay: 1500,
            selectors: {
                ITEMS: '.products-list .product:has(a)',
                NO_RESULTS: '.filter-message.no-results',
                LOADING: '.filter-message.loading'
            },
            filter: {
                logic: '(product AND status)',
                fields: {
                    product: {
                        selector: '.products-navigation select[name="product"]',
                        type: 'select',
                        emptyValue: '*'
                    },
                    status: {
                        selector: '.products-navigation select[name="status"]',
                        type: 'select',
                        emptyValue: '*'
                    }
                }
            },
            on: {
                beforeFilter: (filterState) => {
                    document.querySelectorAll('.products-list-category').forEach(item => item.style.display = 'none');
                },
                filter: (visibleCount, totalCount, filterState, visibleItems) => {
                    visibleItems.forEach(item => {
                        const group = item.closest('.products-list-category');
                        if (group) {
                            group.style.display = '';
                        }
                    });
                }
            }
        });
    }
};